import { ApiServiceBase } from '../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import { AuthService } from 'src/app/core/authentication/auth.service';
import { SeatPropertyReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
  providedIn: 'root'
})
export class SeatPropertyReferenceService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/system/seatpropertyreferences"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getAll(): Observable<SeatPropertyReferenceModel[]> {
    return this.httpGet<any>(this.REFERENCE_PATH, null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }
}